import { border, lodestarColors, ursaColors } from "@smartsheet/design-tokens";
import { neutralLight10, buttonDefault } from "../../../constants/colors";
import { themed } from "../../../util/theme";

export const selectBasicFontTheme = {
    variant: {
        oldestar: {
            system: "lodestar",
            variant: "bodyText",
        },
        "lodestar-light": {
            system: "lodestar",
            variant: "bodyText",
        },
        "ursa-light": {
            system: "ursa",
            variant: "Inter--14px--400w",
        },
    },
} as const;

export const optionFontTheme = {
    variant: {
        oldestar: {
            system: "lodestar",
            variant: "bodyStrong",
        },
        "lodestar-light": {
            system: "lodestar",
            variant: "bodyStrong",
        },
        "ursa-light": {
            system: "ursa",
            variant: "Inter--14px--400w",
        },
    },
} as const;

export const selectV2Theme = themed({
    padding: {
        "lodestar-light": "10px 8px",
        "ursa-light": "9px 8px",
    },
    border: {
        focusedRule: {
            "lodestar-light": "border",
            "ursa-light": "border-bottom",
        },
        focusedRadius: {
            "lodestar-light": border.radius10,
            "ursa-light": "0",
        },
        focusedInset: {
            "lodestar-light": "0px",
            "ursa-light": "1px",
        },
    },
    option: {
        backgroundColor: {
            hover: {
                "lodestar-light": lodestarColors.neutralLight20,
                "ursa-light": ursaColors.neutral50,
            },
            active: {
                "lodestar-light": neutralLight10,
                "ursa-light": ursaColors.neutral75,
            },
        },
        noResults: {
            textAlign: {
                "lodestar-light": "center",
                "ursa-light": "inline-start",
            },
            fontSize: {
                "lodestar-light": "13px",
                "ursa-light": "14px",
            },
        },
    },
    actionButtons: {
        background: {
            hover: {
                "lodestar-light": buttonDefault,
                "ursa-light": ursaColors.neutral50,
            },
            active: {
                "lodestar-light": neutralLight10,
                "ursa-light": ursaColors.neutral75,
            },
        },
        gap: {
            "lodestar-light": "0px",
            "ursa-light": "4px",
        },
        size: {
            "lodestar-light": "32px",
            "ursa-light": "24px",
        },
        borderRadius: {
            "lodestar-light": "4px",
            "ursa-light": "6px",
        },
        margin: {
            top: {
                "lodestar-light": "4px",
                "ursa-light": "8px",
            },
            right: {
                "lodestar-light": "4px",
                "ursa-light": "8px",
            },
        },
    },
});
